import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorStateService, AddressBookQuery, AddressBookService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { Validators, FormBuilder, FormsModule } from '@angular/forms';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { InlineSVGModule } from 'ng-inline-svg';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import * as ɵngcc6 from 'ng-inline-svg';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc9 from '@ngx-translate/core';

function ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(2, 3, "cl.contacts.management.confirm.delete.1"), " ", item_r13.FullName, " ", ɵngcc0.ɵɵpipeBind1(3, 5, "cl.contacts.management.confirm.delete.2"), " ");
} }
function ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 15);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵelementStart(6, "div", 16);
    ɵngcc0.ɵɵelementStart(7, "button", 17);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r13 = ctx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(3); const _r5 = ɵngcc0.ɵɵreference(11); return ctx_r17.edit(item_r13, _r5); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "button", 18);
    ɵngcc0.ɵɵlistener("confirm", function ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_Template_button_confirm_10_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r13 = ctx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.removeContact(item_r13.Id); });
    ɵngcc0.ɵɵelement(11, "span", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_ng_template_12_Template, 4, 7, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    const _r14 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r13.FullName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r13.EmailAddress);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 4, "cl.contacts.management.button.edit"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("confirmContent", _r14);
} }
function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 31);
    ɵngcc0.ɵɵelementStart(6, "button", 32);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_ng_template_20_Template_button_click_6_listener() { const modal_r23 = ctx.$implicit; return modal_r23.close("Close click"); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 33);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_ng_template_20_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r27); const item_r20 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.removeContact(item_r20.Id); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(3, 5, "cl.contacts.management.mobile.confirm.delete.2"), " ", item_r20.FullName, " ", ɵngcc0.ɵɵpipeBind1(4, 7, "cl.contacts.management.mobile.confirm.delete.2"), " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 9, "cl.contacts.management.mobile.button.cancel"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 11, "cl.contacts.management.mobile.button.confirm"), " ");
} }
function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "div", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 23);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div");
    ɵngcc0.ɵɵelementStart(8, "div", 22);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 23);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 24);
    ɵngcc0.ɵɵelementStart(14, "div", 25);
    ɵngcc0.ɵɵelementStart(15, "button", 26);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r30); const item_r20 = ctx.$implicit; const ctx_r29 = ɵngcc0.ɵɵnextContext(3); const _r5 = ɵngcc0.ɵɵreference(11); return ctx_r29.edit(item_r20, _r5); });
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵpipe(17, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "button", 27);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_container_4_ng_container_1_div_16_Template_button_click_18_listener() { ɵngcc0.ɵɵrestoreView(_r30); const _r21 = ɵngcc0.ɵɵreference(21); const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.open(_r21); });
    ɵngcc0.ɵɵelement(19, "span", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(20, ContactsManagementComponent_ng_container_4_ng_container_1_div_16_ng_template_20_Template, 12, 13, "ng-template", null, 28, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 5, "cl.contacts.management.mobile.full.name"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r20.FullName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 7, "cl.contacts.management.mobile.email"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r20.EmailAddress);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(17, 9, "cl.contacts.management.mobile.button.edit"), " ");
} }
function ContactsManagementComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "table", 8);
    ɵngcc0.ɵɵelementStart(3, "thead");
    ɵngcc0.ɵɵelementStart(4, "tr");
    ɵngcc0.ɵɵelementStart(5, "td", 9);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "td", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "tbody");
    ɵngcc0.ɵɵtemplate(13, ContactsManagementComponent_ng_container_4_ng_container_1_tr_13_Template, 14, 6, "tr", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 12);
    ɵngcc0.ɵɵelementStart(15, "div", 13);
    ɵngcc0.ɵɵtemplate(16, ContactsManagementComponent_ng_container_4_ng_container_1_div_16_Template, 22, 11, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const addressBook_r7 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "cl.contacts.management.table.full.name"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 6, "cl.contacts.management.table.email"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", addressBook_r7);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", addressBook_r7);
} }
function ContactsManagementComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵelement(1, "div", 35);
    ɵngcc0.ɵɵelementStart(2, "p", 36);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/address-book.svg");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 3, "cl.contact.management.no.contacts.text"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 5, "cl.contacts.management.empty.list"));
} }
function ContactsManagementComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ContactsManagementComponent_ng_container_4_ng_container_1_Template, 17, 8, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, ContactsManagementComponent_ng_container_4_ng_template_2_Template, 8, 7, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const addressBook_r7 = ctx.ngIf;
    const _r9 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", addressBook_r7.length > 0)("ngIfElse", _r9);
} }
function ContactsManagementComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-loading");
} }
function ContactsManagementComponent_ng_template_8_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 46);
} }
function ContactsManagementComponent_ng_template_8_i_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 46);
} }
function ContactsManagementComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵelementStart(1, "h4", 38);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 39);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_template_8_Template_button_click_4_listener() { const modal_r33 = ctx.$implicit; return modal_r33.dismiss("Cross click"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 29);
    ɵngcc0.ɵɵelementStart(6, "div", 40);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementStart(9, "div", 41);
    ɵngcc0.ɵɵelementStart(10, "input", 42);
    ɵngcc0.ɵɵlistener("ngModelChange", function ContactsManagementComponent_ng_template_8_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.fullName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, ContactsManagementComponent_ng_template_8_span_11_Template, 1, 0, "span", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementStart(14, "div", 41);
    ɵngcc0.ɵɵelementStart(15, "input", 44);
    ɵngcc0.ɵɵlistener("ngModelChange", function ContactsManagementComponent_ng_template_8_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.email = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, ContactsManagementComponent_ng_template_8_i_16_Template, 1, 0, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "button", 45);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_template_8_Template_button_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.addContact(); });
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "fgbcl-errors");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 9, "cl.contacts.management.add.contact.modal.header"), " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 11, "cl.contact.management.add.contact.modal.full.name.text"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.fullName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.fullName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 13, "cl.contact.management.add.contact.modal.email.text"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r4.fullName || !ctx_r4.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(19, 15, "cl.contacts.management.add.contact.modal.button.add"), " ");
} }
function ContactsManagementComponent_ng_template_10_i_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 46);
} }
function ContactsManagementComponent_ng_template_10_i_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 46);
} }
function ContactsManagementComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r46 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵelementStart(1, "h4", 38);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 39);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_template_10_Template_button_click_4_listener() { const modal_r41 = ctx.$implicit; return modal_r41.dismiss("Cross click"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 29);
    ɵngcc0.ɵɵelementStart(6, "div", 40);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementStart(9, "div", 41);
    ɵngcc0.ɵɵelementStart(10, "input", 47);
    ɵngcc0.ɵɵlistener("ngModelChange", function ContactsManagementComponent_ng_template_10_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r46); const ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.fullName = $event; });
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, ContactsManagementComponent_ng_template_10_i_12_Template, 1, 0, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementStart(15, "div", 41);
    ɵngcc0.ɵɵelementStart(16, "input", 48);
    ɵngcc0.ɵɵlistener("ngModelChange", function ContactsManagementComponent_ng_template_10_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r46); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.email = $event; });
    ɵngcc0.ɵɵpipe(17, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, ContactsManagementComponent_ng_template_10_i_18_Template, 1, 0, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "button", 45);
    ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_ng_template_10_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r46); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.addContact(); });
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(22, "fgbcl-errors");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 11, "cl.contacts.management.edit.contact.modal.header"), " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 13, "cl.contacts.management.edit.contact.modal.full.name"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(11, 15, "cl.contacts.management.edit.contact.modal.full.name"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.fullName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.fullName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 17, "cl.contacts.management.edit.contact.modal.email"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(17, 19, "cl.contacts.management.edit.contact.modal.email"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.email);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r6.fullName || !ctx_r6.email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(21, 21, "cl.contacts.management.edit.contact.modal.button.edit"), " ");
} }
class ContactsManagementComponent {
    constructor(errorStateService, addressBookQuery, addressService, modalService, formBuilder) {
        this.errorStateService = errorStateService;
        this.addressBookQuery = addressBookQuery;
        this.addressService = addressService;
        this.modalService = modalService;
        this.formBuilder = formBuilder;
        this.addNew = false;
    }
    ngOnInit() {
        this.getAddressBookList();
        this.contactForm = this.formBuilder.group({
            EmailAddress: [this.email, Validators.email, Validators.required],
            FullName: [this.fullName, Validators.required],
        });
    }
    getAddressBookList() {
        this.addressBook$ = this.addressBookQuery
            .selectAllContacts()
            .pipe(map((contactsList) => contactsList.sort((a, b) => a.FullName.localeCompare(b.FullName))));
    }
    addContact() {
        this.addressService
            .add(this.fullName, this.email)
            .toPromise()
            .then(() => this.modalService.dismissAll())
            .catch((error) => {
            this.errorStateService.addError(error);
            setTimeout(() => this.errorStateService.clearErrors(), 3000);
        });
    }
    removeContact(id) {
        this.addressService.remove(id).toPromise();
        this.modalService.dismissAll();
    }
    add(content) {
        this.fullName = '';
        this.email = '';
        this.open(content);
    }
    edit(item, content) {
        this.contactId = item.Id === undefined ? 0 : item.Id;
        this.fullName = item.FullName;
        this.email = item.EmailAddress;
        this.open(content);
    }
    updateContact() {
        this.addressService
            .update(this.contactId, this.fullName, this.email)
            .toPromise()
            .then(() => this.modalService.dismissAll())
            .catch((error) => {
            this.errorStateService.addError(error);
            setTimeout(() => this.errorStateService.clearErrors(), 3000);
        });
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' }).result.then((result) => { }, (reason) => { });
    }
}
ContactsManagementComponent.ɵfac = function ContactsManagementComponent_Factory(t) { return new (t || ContactsManagementComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AddressBookQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AddressBookService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
ContactsManagementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ContactsManagementComponent, selectors: [["fgbcl-contacts-management"]], decls: 12, vars: 7, consts: [[1, "contact-management-add-button", 3, "click"], [1, "icon-plus-circle"], [4, "ngIf", "ngIfElse"], ["loading", ""], ["addNewContactForm", ""], ["editContactForm", ""], ["noContacts", ""], [1, "d-none", "d-lg-block"], [1, "table", "contact-management-table"], [1, "contact-management-table-row-text"], [1, "text-center"], [4, "ngFor", "ngForOf"], [1, "d-block", "d-lg-none"], [1, "card", "p-4"], ["class", "mt-3 mb-3", 4, "ngFor", "ngForOf"], [1, "contact-management-table-cell"], [1, "d-flex", "justify-content-around"], [1, "btn", "btn-primary", "contact-management-edit-btn", 3, "click"], ["confirmModal", "", "aria-label", "Remove contact", 1, "btn", "btn-primary", "contact-management-delete-btn", 3, "confirmContent", "confirm"], [1, "icon-trash"], ["confirmContent", ""], [1, "mt-3", "mb-3"], [1, "sub-title"], [1, "result-field", "bg-muted", "p-2"], [1, "row"], [1, "container", "mt-2", "mb-3"], [1, "col-3", "btn", "btn-primary", "btn-remove-contact", 3, "click"], ["aria-label", "Delete contact", 1, "col-2", "offset-7", "btn", "btn-danger", "btn-remove-contact", 3, "click"], ["confirmDelete", ""], [1, "modal-body"], ["body", "", 1, "text-center", "color-secondary", "p-3", "font-size-14"], [1, "btn-container"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], ["type", "button", 1, "btn", "btn-success", 3, "click"], [1, "no-contacts", "text-center"], [1, "icon", "svg", "no-contacts-icon", 3, "inlineSVG"], [1, "text-primary"], [1, "modal-header"], ["id", "modal-basic-title", 1, "modal-title", "text-center"], ["type", "button", "aria-label", "Close", 1, "close", "icon-cancel-circle", "modal-close-icon", 3, "click"], [1, "form-group", "h-100", "d-flex", "flex-column", "justify-content-between"], [1, "form-div"], ["type", "text", 1, "form-control", "bg-muted", 3, "ngModel", "ngModelChange"], ["class", "icon-pencil-1", 4, "ngIf"], ["type", "email", 1, "form-control", "bg-muted", 3, "ngModel", "ngModelChange"], [1, "btn", "btn-primary", 3, "disabled", "click"], [1, "icon-pencil-1"], ["type", "text", 1, "form-control", "bg-muted", 3, "placeholder", "ngModel", "ngModelChange"], ["type", "email", 1, "form-control", "bg-muted", 3, "placeholder", "ngModel", "ngModelChange"]], template: function ContactsManagementComponent_Template(rf, ctx) { if (rf & 1) {
        const _r49 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function ContactsManagementComponent_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r49); const _r3 = ɵngcc0.ɵɵreference(9); return ctx.add(_r3); });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, ContactsManagementComponent_ng_container_4_Template, 4, 2, "ng-container", 2);
        ɵngcc0.ɵɵpipe(5, "async");
        ɵngcc0.ɵɵtemplate(6, ContactsManagementComponent_ng_template_6_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, ContactsManagementComponent_ng_template_8_Template, 21, 17, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, ContactsManagementComponent_ng_template_10_Template, 23, 23, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "cl.contacts.management.add.new.contact"), "\n");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(5, 5, ctx.addressBook$))("ngIfElse", _r1);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc5.ConfirmModalDirective, ɵngcc6.InlineSVGDirective, ɵngcc7.LoadingComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc8.ErrorsComponent], pipes: [ɵngcc9.TranslatePipe, ɵngcc4.AsyncPipe], styles: [".sub-title[_ngcontent-%COMP%]{font-size:12px}.form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:1;width:100%;margin:15px 0}.add-new-contact-btn[_ngcontent-%COMP%]{cursor:pointer;margin:20px 0;font-size:12px}.add-new-contact-btn[_ngcontent-%COMP%]:hover{text-decoration:underline}.no-contacts[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:20px;font-weight:700;margin-bottom:0}.no-contacts[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:16px;font-weight:700}.no-contacts-icon[_ngcontent-%COMP%]{width:130px;display:block;margin-left:auto;margin-right:auto}.modal-body[_ngcontent-%COMP%]{padding:40px 70px}.result-field[_ngcontent-%COMP%]{border-radius:4px;font-size:14px}"] });
ContactsManagementComponent.ctorParameters = () => [
    { type: ErrorStateService },
    { type: AddressBookQuery },
    { type: AddressBookService },
    { type: NgbModal },
    { type: FormBuilder }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContactsManagementComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-contacts-management',
                template: "<div (click)=\"add(addNewContactForm)\" class=\"contact-management-add-button\">\r\n  <span class=\"icon-plus-circle\"></span>\r\n  {{ 'cl.contacts.management.add.new.contact' | translate }}\r\n</div>\r\n<ng-container *ngIf=\"addressBook$ | async as addressBook; else loading\">\r\n  <ng-container *ngIf=\"addressBook.length > 0; else noContacts\">\r\n    <div class=\"d-none d-lg-block\">\r\n      <table class=\"table contact-management-table\">\r\n        <thead>\r\n          <tr>\r\n            <td class=\"contact-management-table-row-text\">{{ 'cl.contacts.management.table.full.name' | translate }}</td>\r\n            <td class=\"contact-management-table-row-text\">{{ 'cl.contacts.management.table.email' | translate }}</td>\r\n            <td class=\"text-center\"></td>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let item of addressBook\">\r\n            <td class=\"contact-management-table-cell\">{{ item.FullName }}</td>\r\n            <td class=\"contact-management-table-cell\">{{ item.EmailAddress }}</td>\r\n            <td>\r\n              <div class=\"d-flex justify-content-around\">\r\n                <button (click)=\"edit(item, editContactForm)\" class=\"btn btn-primary contact-management-edit-btn\">\r\n                  {{ 'cl.contacts.management.button.edit' | translate }}\r\n                </button>\r\n                <button\r\n                  class=\"btn btn-primary contact-management-delete-btn\"\r\n                  confirmModal\r\n                  [confirmContent]=\"confirmContent\"\r\n                  (confirm)=\"removeContact(item.Id)\"\r\n                  aria-label=\"Remove contact\"\r\n                >\r\n                  <span class=\"icon-trash\"></span>\r\n                </button>\r\n                <ng-template #confirmContent\r\n                  ><div class=\"text-center\">\r\n                    {{ 'cl.contacts.management.confirm.delete.1' | translate }} {{ item.FullName }}\r\n                    {{ 'cl.contacts.management.confirm.delete.2' | translate }}\r\n                  </div></ng-template\r\n                >\r\n              </div>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"d-block d-lg-none\">\r\n      <div class=\"card p-4\">\r\n        <div class=\"mt-3 mb-3\" *ngFor=\"let item of addressBook\">\r\n          <div>\r\n            <div class=\"sub-title\">{{ 'cl.contacts.management.mobile.full.name' | translate }}</div>\r\n            <div class=\"result-field bg-muted p-2\">{{ item.FullName }}</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"sub-title\">{{ 'cl.contacts.management.mobile.email' | translate }}</div>\r\n            <div class=\"result-field bg-muted p-2\">{{ item.EmailAddress }}</div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"container mt-2 mb-3\">\r\n              <button (click)=\"edit(item, editContactForm)\" class=\"col-3 btn btn-primary btn-remove-contact\">\r\n                {{ 'cl.contacts.management.mobile.button.edit' | translate }}\r\n              </button>\r\n              <button\r\n                (click)=\"open(confirmDelete)\"\r\n                class=\"col-2 offset-7 btn btn-danger btn-remove-contact\"\r\n                aria-label=\"Delete contact\"\r\n              >\r\n                <span class=\"icon-trash\"></span>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <ng-template #confirmDelete let-modal>\r\n            <div class=\"modal-body\">\r\n              <div body class=\"text-center color-secondary p-3 font-size-14\">\r\n                {{ 'cl.contacts.management.mobile.confirm.delete.2' | translate }} {{ item.FullName }}\r\n                {{ 'cl.contacts.management.mobile.confirm.delete.2' | translate }}\r\n              </div>\r\n              <div class=\"btn-container\">\r\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"modal.close('Close click')\">\r\n                  {{ 'cl.contacts.management.mobile.button.cancel' | translate }}\r\n                </button>\r\n                <button type=\"button\" class=\"btn btn-success\" (click)=\"removeContact(item.Id)\">\r\n                  {{ 'cl.contacts.management.mobile.button.confirm' | translate }}\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #noContacts>\r\n    <div class=\"no-contacts text-center\">\r\n      <div class=\"icon svg no-contacts-icon\" [inlineSVG]=\"'assets/images/icons/address-book.svg'\"></div>\r\n      <p class=\"text-primary\">{{ 'cl.contact.management.no.contacts.text' | translate }}</p>\r\n      <span>{{ 'cl.contacts.management.empty.list' | translate }}</span>\r\n    </div>\r\n  </ng-template>\r\n</ng-container>\r\n<ng-template #loading>\r\n  <fgbcl-loading></fgbcl-loading>\r\n</ng-template>\r\n<!-- Add New Modal -->\r\n<ng-template #addNewContactForm let-modal>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title text-center\" id=\"modal-basic-title\">\r\n      {{ 'cl.contacts.management.add.contact.modal.header' | translate }}\r\n    </h4>\r\n    <button\r\n      type=\"button\"\r\n      class=\"close icon-cancel-circle modal-close-icon\"\r\n      aria-label=\"Close\"\r\n      (click)=\"modal.dismiss('Cross click')\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div class=\"form-group h-100 d-flex flex-column justify-content-between\">\r\n      {{ 'cl.contact.management.add.contact.modal.full.name.text' | translate }}\r\n      <div class=\"form-div\">\r\n        <input type=\"text\" class=\"form-control bg-muted\" [(ngModel)]=\"fullName\" />\r\n        <span *ngIf=\"fullName\" class=\"icon-pencil-1\"></span>\r\n      </div>\r\n      {{ 'cl.contact.management.add.contact.modal.email.text' | translate }}\r\n      <div class=\"form-div\">\r\n        <input type=\"email\" class=\"form-control bg-muted\" [(ngModel)]=\"email\" />\r\n        <i *ngIf=\"email\" class=\"icon-pencil-1\"></i>\r\n      </div>\r\n      <button class=\"btn btn-primary\" [disabled]=\"!fullName || !email\" (click)=\"addContact()\">\r\n        {{ 'cl.contacts.management.add.contact.modal.button.add' | translate }}\r\n      </button>\r\n    </div>\r\n    <fgbcl-errors></fgbcl-errors>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Edit Modal -->\r\n<ng-template #editContactForm let-modal>\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title text-center\" id=\"modal-basic-title\">\r\n      {{ 'cl.contacts.management.edit.contact.modal.header' | translate }}\r\n    </h4>\r\n    <button\r\n      type=\"button\"\r\n      class=\"close icon-cancel-circle modal-close-icon\"\r\n      aria-label=\"Close\"\r\n      (click)=\"modal.dismiss('Cross click')\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div class=\"form-group h-100 d-flex flex-column justify-content-between\">\r\n      {{ 'cl.contacts.management.edit.contact.modal.full.name' | translate }}\r\n      <div class=\"form-div\">\r\n        <input\r\n          type=\"text\"\r\n          class=\"form-control bg-muted\"\r\n          placeholder=\"{{ 'cl.contacts.management.edit.contact.modal.full.name' | translate }}\"\r\n          [(ngModel)]=\"fullName\"\r\n        />\r\n        <i *ngIf=\"fullName\" class=\"icon-pencil-1\"></i>\r\n      </div>\r\n      {{ 'cl.contacts.management.edit.contact.modal.email' | translate }}\r\n      <div class=\"form-div\">\r\n        <input\r\n          type=\"email\"\r\n          class=\"form-control bg-muted\"\r\n          placeholder=\"{{ 'cl.contacts.management.edit.contact.modal.email' | translate }}\"\r\n          [(ngModel)]=\"email\"\r\n        />\r\n        <i *ngIf=\"email\" class=\"icon-pencil-1\"></i>\r\n      </div>\r\n      <button class=\"btn btn-primary\" [disabled]=\"!fullName || !email\" (click)=\"addContact()\">\r\n        {{ 'cl.contacts.management.edit.contact.modal.button.edit' | translate }}\r\n      </button>\r\n    </div>\r\n    <fgbcl-errors></fgbcl-errors>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [".sub-title{font-size:12px}.form-group input{border:1;width:100%;margin:15px 0}.add-new-contact-btn{cursor:pointer;margin:20px 0;font-size:12px}.add-new-contact-btn:hover{text-decoration:underline}.no-contacts p{font-size:20px;font-weight:700;margin-bottom:0}.no-contacts span{font-size:16px;font-weight:700}.no-contacts-icon{width:130px;display:block;margin-left:auto;margin-right:auto}.modal-body{padding:40px 70px}.result-field{border-radius:4px;font-size:14px}"]
            }]
    }], function () { return [{ type: ɵngcc1.ErrorStateService }, { type: ɵngcc1.AddressBookQuery }, { type: ɵngcc1.AddressBookService }, { type: ɵngcc2.NgbModal }, { type: ɵngcc3.FormBuilder }]; }, null); })();

class ContactsManagementModule {
}
ContactsManagementModule.ɵfac = function ContactsManagementModule_Factory(t) { return new (t || ContactsManagementModule)(); };
ContactsManagementModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ContactsManagementModule });
ContactsManagementModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ConfirmModalModule,
            ErrorsModule,
            InlineSVGModule,
            LoadingModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ContactsManagementModule, { declarations: function () { return [ContactsManagementComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ConfirmModalModule,
        ErrorsModule,
        InlineSVGModule,
        LoadingModule, ɵngcc9.TranslateModule]; }, exports: function () { return [ContactsManagementComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContactsManagementModule, [{
        type: NgModule,
        args: [{
                declarations: [ContactsManagementComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ConfirmModalModule,
                    ErrorsModule,
                    InlineSVGModule,
                    LoadingModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [ContactsManagementComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ContactsManagementComponent, ContactsManagementModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-contacts-management.js.map